import { useNavigate } from "@tanstack/react-router";
import { useCallback } from "react";

/**
 * Optimized hook for task navigation that minimizes router re-computation.
 * Uses direct search parameter manipulation for better performance.
 */
export function useTaskNavigation() {
    const navigate = useNavigate();

    const openTask = useCallback(
        (taskId: number, tab?: "activity" | "description") => {
            // Use navigate with a memoized search function to prevent unnecessary re-computations
            navigate({
                to: ".",
                search: (prev) => ({ ...prev, task: taskId, tab: tab || undefined }),
                // Prevent full page re-render by keeping the same route
                replace: false,
            });
        },
        [navigate]
    );

    const closeTask = useCallback(() => {
        navigate({
            to: ".",
            search: (prev) => ({ ...prev, task: undefined, tab: undefined }),
            replace: false,
        });
    }, [navigate]);

    return { openTask, closeTask };
}
